document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook("beforeRecommendHitTemplate", function (_defaultTemplate, html, item) {
    const itemHandle =
      item && algoliaShopify?.helpers?.instantsearchLink ? algoliaShopify.helpers.instantsearchLink(item) : "";
    const product = {
      id: item.id,
      variant: item.objectID,
      vendor: item.vendor,
      title: item.title,
      condition: item.meta?.custom?.condition ?? null,
      price: item.price,
      compare_at_price: item.compare_at_price,
      url: "https://" + window.location.host + itemHandle,
      image: algoliaShopify.helpers.largeImage(item),
      alt: item.title,
      inventory_quantity: item.inventory_quantity,
      handle: item.handle,
      social_count: item.meta?.swym_wishlist?.wishlist_social_count ?? null,
      images: item.images,
    };

    const onClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.location.assign(url);
    };

    return html`${renderInjectedProductCard(product, onClick, item, html)}`;
  });
});

window.addEventListener("load", function () {
  const algoliaRecommendedWrapper = document.querySelector("[id^=alg-recommend-wrapper_]");
  const algoliaRecommendedSection = document.querySelector("[id^=horizontal-slider-]");
  if (!algoliaRecommendedSection) return;

  /* Observable to prevent race condition */
  const recommendedSectionObserver = new MutationObserver((entries) => {
    entries.forEach((entry) => {
      /* Run when the Algolia recommended slider is present */
      if (entry.target.id.includes("horizontal-slider-")) {
        algoliaRecommendedSection.querySelectorAll(".fp-injected-secondary-image").forEach(async (img) => {
          const handle = img.dataset.productHandle;
          if (!handle) return;
          const secondaryImage = await getSecondaryImageByHandle(handle);
          if (secondaryImage) {
            img.src = secondaryImage;
          }
        });
        /* Done fetching secondary images, the observer is no longer needed */
        recommendedSectionObserver.disconnect();
        // NOTE: remove skeleton once it's loaded
        window.removeCarouselSkeleton(algoliaRecommendedWrapper);
      }
    });
    document.dispatchEvent(new Event("swym:update-social-count"));
  });

  recommendedSectionObserver.observe(algoliaRecommendedSection, { childList: true, subtree: true });
});
